"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/* Captured From PROD at http://localhost:3000/en */
var DEFAULT_PROPS = {
  id: 'language-masters_en_1547723311172',
  resourceType: 'DiscoverySection_1_0_0',
  lastModified: '1547723311172',
  heading1: 'Safety',
  heading2: 'Introducing Active Stability Control (ASC)',
  heading3: null,
  price: null,
  textBlock: 'Sensors throughout the car can detect any unstable movement. If the car starts to slip or slide, the Active Stability Control (ASC) automatically regulates the brakes and engine to stabilise the vehicle.',
  textBlockPosition: 'rightTop',
  sectionTitle: null,
  sectionId: null,
  vehicleLogo: null,
  tag: null,
  featureBlock: [],
  cta: {
    label: 'Learn More',
    URL: '/en/cars/outlander-phev/safety',
    priority: 'low',
    openNewTab: false,
    theme: null,
    icon: null,
    ctaType: null,
    __typename: 'Link'
  },
  link: {
    label: 'Learn More',
    URL: '/en/cars/outlander-phev/safety',
    priority: 'low',
    openNewTab: false,
    theme: null,
    icon: null,
    ctaType: null,
    __typename: 'Link'
  },
  backgroundImage: null,
  image: {
    image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-glue/Home_ASC.jpg',
    altText: 'Active stability control',
    __typename: 'Image'
  },
  video: {
    source: null,
    autoplay: null,
    muted: null,
    loop: null,
    poster: null,
    __typename: 'Video'
  },
  size: null,
  aspectRatio: null,
  carAlignment: null,
  theme: null,
  __typename: 'FullWidthPanel'
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;